import { useEffect, useState } from 'react';
import { fetchHistoricalNavigation } from '../services/network';
import type {
    HistoricalNavigationEntry,
    HistoricalNavigation as HistoricalNavigationType,
} from '../types/models';
import type { Execute } from '../types/public/component-props';

type Props = {
    tenantId: string;
    stateId: string;
    stateToken: string;
    currentMapElementName: string;
    execute: Execute;
};

const HistoricalNavigation = ({
    tenantId,
    stateId,
    stateToken,
    currentMapElementName,
    execute,
}: Props) => {
    const [expanded, setExpanded] = useState(false);
    const [navigation, setNavigation] = useState<HistoricalNavigationType | null>(null);
    const [currentPageName, setCurrentPageName] = useState<string | null>(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: This needs to be called when the stateToken changes because that indicates that the flow has been invoked.
    useEffect(() => {
        fetchHistoricalNavigation({ tenantId, stateId }).then((response) => {
            if (response) {
                setNavigation(response);
                setCurrentPageName(currentMapElementName);
                setExpanded(false);
            }
        });
    }, [tenantId, stateId, stateToken, currentMapElementName]);

    const onEntryClick = (entry: HistoricalNavigationEntry) => {
        setExpanded(false);
        execute({
            invokeType: 'NAVIGATE',
            selectedStateEntryId: entry.stateEntryId,
        });
    };

    if (navigation === null || navigation.entries === null) {
        return null;
    }

    return (
        <nav className={`historical-navigation${expanded ? ' expanded' : ''}`}>
            <ul>
                {navigation.entries.map((entry, index) => (
                    <li key={entry.stateEntryId}>
                        <button
                            className="link-emulate"
                            onClick={() => onEntryClick(entry)}
                            type="button"
                        >
                            {entry.mapElementName}
                        </button>
                        {index === 0 ? (
                            <button
                                title="expand"
                                className="historical-navigation-expand"
                                onClick={() => setExpanded(true)}
                                type="button"
                            >
                                <span>expand</span>
                            </button>
                        ) : null}
                    </li>
                ))}

                <li key={'current'}>
                    <span className="historical-navigation-current">{currentPageName}</span>
                </li>
            </ul>
        </nav>
    );
};

export default HistoricalNavigation;
